import { render, staticRenderFns } from "./simple_Keyboard.vue?vue&type=template&id=5f0a9e68&scoped=true"
import script from "./simple_Keyboard.vue?vue&type=script&lang=js"
export * from "./simple_Keyboard.vue?vue&type=script&lang=js"
import style0 from "./simple_Keyboard.vue?vue&type=style&index=0&id=5f0a9e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a9e68",
  null
  
)

export default component.exports